import React from 'react';
import style from '../../pages/SearchResults/SearchResults.module.css';
import { useTranslation } from "react-i18next";
import noImage from '../../assets/images/noImage.png';
import { filterLanguage, filterProperties } from './../../utilities/filterFunction';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { basename } from './../../configiration/config';
import { imgResize } from './../../utilities/imageResize';

export default function Propertycard({ property, propertyLocales }) {
  const { t, i18n } = useTranslation();
  let [diffLanguage, setDifLanguage] = useState([])
  useEffect(() => {
    let lang;
    if (i18n.language === 'ar') {
      lang = 'en'
    } else if (i18n.language === 'en') {
      lang = 'ar'
    }
    setDifLanguage(filterProperties(property.locales, lang))
    // eslint-disable-next-line
  }, [])
  return (
    <>
      <div className={`${style.propertyCard} ${i18n.language === "en" ? "englishCard" : "arabicCard"
        } ${style.no1} card h-100`} >
        <Link to={`${basename}/property-details/${property.slug}`} state={{propertyId:property}} className={`${style.propertyCardImgContainer}`}>
          <div className={`${style.propertyCardImgNested}`}>
            <img
              src={`${imgResize(property.image,630,340)}`}
              className={`${style.propertyCardImg}`}
              alt={property.slug}
              onError={(e) => { e.target.src = noImage }}
            />
            <div className={`${style.propertyCardContent} ${i18n.language === "ar" ? style.propertyCardContent2 :''} `}>
              {property.facilities &&
                property.facilities.length > 0 &&
                property.facilities.slice(0,6).map((faclity) => {
                  let selectedFacilty = filterLanguage(faclity.locales)
                  return (
                    <div
                      key={faclity.slug}
                      className={`${style.homeOptions}`}
                    >
                      <span className={`${style.popup}`}>
                        {selectedFacilty.length > 0 ? selectedFacilty[0].name : ''}
                      </span>
                      <img
                        src={`${imgResize(faclity.image,40,40)}`}
                        alt={faclity.slug}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </Link>
        <div className={`${style.cardBody} card-body pt-0`}>
         <Link to={`${basename}/property-details/${ propertyLocales.length === 0 ? (diffLanguage.length > 0 && diffLanguage[0].title) : propertyLocales[0].title}`} state={{propertyId:property}}>
            <h5 className="card-title mb-0">
              {propertyLocales.length === 0 ? (diffLanguage.length > 0 && diffLanguage[0].title) : propertyLocales[0].title}
            </h5>
         </Link>
          <div
            className={`${style.numbersDetails} mb-2`}
          >
            <span className={`${style.propertyInfo}`}>
            {property.space !==0 ? 
              <span>{property.space} {t('meter')} / </span>
              :""} 
              <span>{property.person} {t('person')}</span>
            </span>
            {property.price ? (
              <span className='d-flex'>
                <span className={`${style.fromWord}`}>
                  {t('from')} 
                </span>
                <span className={`${style.price}`}>
                  {property.price} {t('aed')}
                </span>
              </span>
            ):""}
          </div>
          {/* <div className={`card-text ${style.myCardText}`}>
            {propertyLocales.length === 0 ? (diffLanguage.length > 0 && diffLanguage[0].title) : parse(propertyLocales[0].short_description)}
          </div> */}
        </div>
      </div>
    </>
  )
}
